import { Link } from 'react-router-dom';
import styles from './LandingPage.module.css';
import logo from '../../assets/logo.webp';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';

const LandingPage = () => {
  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="Gymnaze Logo" className={styles.logo} />
      <div className={styles.buttonGroup}>
        <Link to="/login/enter-credentials">
          <button className={globalButtonStyles.button}>Log In</button>
        </Link>
        <Link to="/signup/select-role">
          <button className={globalButtonStyles.button}>Sign Up</button>
        </Link>
      </div>
    </div>
  );
};

export default LandingPage;